import React, { useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Card } from '../ui/Card';
import { TrendPoint, User } from '../../types/dashboard';
import { Select } from '../ui/Select';
interface TrendChartProps {
  data: TrendPoint[];
  users: User[];
}
export function TrendChart({
  data,
  users
}: TrendChartProps) {
  const [selectedMetric, setSelectedMetric] = useState<string[]>(['applications']);
  const metricOptions = [{
    value: 'calls',
    label: 'Calls'
  }, {
    value: 'transfers',
    label: 'Transfers'
  }, {
    value: 'applications',
    label: 'Applications'
  }, {
    value: 'documents',
    label: 'Documents Out'
  }, {
    value: 'submissions',
    label: 'Submissions'
  }];
  const colors = ['#1e40af', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6'];
  return <Card title="Historical Performance Trends" className="flex flex-col" data-id="element-153">
      <div className="mb-6" data-id="element-154">
        <label className="block text-xs font-medium text-gray-600 uppercase tracking-wide mb-2" data-id="element-155">
          Select Metric
        </label>
        <div className="w-full sm:w-64" data-id="element-156">
          <Select options={metricOptions} value={selectedMetric} onChange={setSelectedMetric} placeholder="Select metric" data-id="element-157" />
        </div>
      </div>

      <div className="flex-1 w-full" style={{
      height: '350px'
    }} data-id="element-158">
        <ResponsiveContainer width="100%" height="100%" data-id="element-159">
          <LineChart data={data} margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5
        }} data-id="element-160">
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-161" />
            <XAxis dataKey="date" axisLine={false} tickLine={false} tick={{
            fill: '#6b7280',
            fontSize: 12
          }} dy={10} data-id="element-162" />
            <YAxis axisLine={false} tickLine={false} tick={{
            fill: '#6b7280',
            fontSize: 12
          }} data-id="element-163" />
            <Tooltip contentStyle={{
            backgroundColor: '#fff',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }} itemStyle={{
            fontSize: '12px',
            fontWeight: 500
          }} data-id="element-164" />
            <Legend wrapperStyle={{
            paddingTop: '20px'
          }} data-id="element-165" />

            <Line type="monotone" dataKey={selectedMetric[0]} name={metricOptions.find(o => o.value === selectedMetric[0])?.label} stroke="#1e40af" strokeWidth={3} dot={{
            r: 4,
            fill: '#1e40af',
            strokeWidth: 2,
            stroke: '#fff'
          }} activeDot={{
            r: 6
          }} data-id="element-166" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </Card>;
}